import styled, { css } from 'styled-components';
import StylableRouterLink from '~components/StylableRouterLink';
import { Props } from './index';

type ButtonCSSProps = {
  borderRadius?: Props['borderRadius'];
  bgColor: Props['bgColor'];
  color: Props['color'];
};

type ButtonLinkProps = ButtonCSSProps & { disabled?: boolean };

const disabledCSS = css`
  pointer-events: none;
  cursor: auto;
  opacity: 0.6;
`;

const disabledPropHandler = ({ disabled }: { disabled?: boolean }) =>
  disabled && disabledCSS;

const buttonCSS = css<ButtonCSSProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  border: none;

  &:hover {
    cursor: pointer;
  }

  &:disabled {
    ${disabledCSS};
  }

  ${({ borderRadius, bgColor, color }) =>
    `
      color: ${color};
      background-color: ${bgColor};
      border-radius: ${(borderRadius === 'rounded' && '30px') ||
        (borderRadius === 'slightlyRounded' && '5px') ||
        '0'};
    `}
`;

export const StyledButton = styled.button`
  ${buttonCSS};
`;

export const ButtonRouterLink = styled(StylableRouterLink)<ButtonLinkProps>`
  ${buttonCSS};
  ${disabledPropHandler}
`;

export const ButtonLink = styled.a<ButtonLinkProps>`
  ${buttonCSS};
  ${disabledPropHandler}
`;

export const ChildWrapper = styled.span<{ hasLeftMargin?: boolean }>`
  ${({ hasLeftMargin }) =>
    hasLeftMargin &&
    `
    margin-left: 10px;
  `}
`;
